export default __webpack_public_path__ + "static/media/icon-social-tw.4fada782.svg";